export const getIsLoading = (state) => state.compaign.isApiLoading;
export const getIsGeneratingLoading = (state) => state.compaign.isGeneratingFileApiLoading;
export const getIsDownloadingOcrLoading = (state) => state.compaign.isDownloadingFileOcrApiLoading;
export const getIsDownloadingCsvLoading = (state) => state.compaign.isDownloadingFileCsvApiLoading;
export const getIsDeletingCampaignLoading = (state) => state.compaign.isDeletingCampaignApiLoading
export const getCreatedCompaign = (state) => state.compaign.createdCompaign;
export const allCampaign = (state) => state.compaign.allCampaign;